export default __webpack_public_path__ + "static/media/bg-9.9335b330.jpg";